import React from 'react'
import { ImagenesGlobal } from './ImagenesGlobal';

const ProfileContent = ({ profile_url, style = ({}), loadImageS, signal = false, className = '' }) => { //URL del perfil de un usuario X

  return (
    <div className={'profile-img ' + className} style={style}>
      <ImagenesGlobal
        signal={signal}
        url={profile_url ?? null}
        alt='Perfil Usuarios'
        type={'profile'}
        loadImageS={loadImageS}
        key={profile_url}
      />
    </div>
  )
}

export default ProfileContent

